import { all, fork } from 'redux-saga/effects'
import { watchFeedback, watchSendFeedback } from 'easycommons/modules/Feedback'
import watchAddressInfo from './modules/addressInfo'
import watchInvestorProfile from './modules/investorProfile'
import watchBankAccounts from './modules/bankAccount'
import watchBusinessInfo from './modules/businessInfo'
import watchCustomerAccount from './modules/customerAccount'
import watchPersonalInfo from './modules/personalInfo'
import watchFinancialTransferAccounts from './modules/financialTransferAccounts'
import watchTransferSecurity from './modules/transferSecurity'
import { watchBanksList, watchBankInfo } from './modules/bankInfo'
import watchTransactionHistory from './modules/transactionHistory'
import watchAccountStatement from './modules/accountStatement'
import { watchIncomeReport, watchPostIncomeReport } from './modules/incomeReport'
import watchIrrf from './modules/irrf'
import watchInvoices from './modules/invoices'
import watchFinancialSituation from './modules/financialSituation'
import financialPosition from './modules/financialPosition'
import account from './modules/account'
import watchPendency from './modules/pendency'
import watchFeatureToggle from './modules/featureToggle'
import watchEasyToken from './modules/easyToken'
import watchMaritalStatusOptions from './modules/maritalStatusOptions'
import watchWithdrawal from './modules/withdrawal'
import watchYearsIncomeReport from './modules/yearsIncomeReport'
import watchNotifications from './modules/notifications'
import watchBrokers from './modules/brokers'
import watchCustodyInvestments from './modules/custodyInvestments'
import watchCustodyAndPosition from './modules/custodyAndPosition'
import watchAccountsFinancialPosition from './modules/accountsFinancialPosition'

export default function *rootSaga() {
  yield all([
    fork(watchInvestorProfile),
    fork(watchFinancialTransferAccounts),
    fork(watchAddressInfo),
    fork(watchBankAccounts),
    fork(watchBusinessInfo),
    fork(watchCustomerAccount),
    fork(watchPersonalInfo),
    fork(watchTransferSecurity),
    fork(watchBanksList),
    fork(watchBankInfo),
    fork(watchTransactionHistory),
    fork(watchAccountStatement),
    fork(watchIncomeReport),
    fork(watchPostIncomeReport),
    fork(watchFinancialSituation),
    fork(watchIrrf),
    fork(watchInvoices),
    fork(financialPosition),
    fork(account),
    fork(watchFeedback),
    fork(watchSendFeedback),
    fork(watchPendency),
    fork(watchFeatureToggle),
    fork(watchMaritalStatusOptions),
    fork(watchEasyToken),
    fork(watchWithdrawal),
    fork(watchYearsIncomeReport),
    fork(watchNotifications),
    fork(watchBrokers),
    fork(watchCustodyInvestments),
    fork(watchCustodyAndPosition),
    fork(watchAccountsFinancialPosition)
  ])
}
